<template>
    <div>
        <nav-breadcrumb :menu="[{label: '用印申请'}]"/>
        <div class="bg-purple of">
            <el-tabs v-model="applicationStatus">
                <el-tab-pane label="待审核" name="Pending Approval" />
                <el-tab-pane label="已审核" name="Approved,Rejected,Withdrawn" />
            </el-tabs>
            <div class="xzpadd10 of">
                <data-table
                    :table-data="tableData"
                    :columns="columns"
                    :page.sync="page"
                    :pageSize.sync="pageSize"
                    :filters.sync="filters"
                    :actions="actions"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import Status2CN from "../../filters/Status2CN";
    import moment from 'moment'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "ContractSealProcessList",
        data(){
            return{
                applicationStatus: 'Pending Approval',
                tableData: {
                    count: 0,
                    data: []
                },
                dealerTypeOptions:[],
                page: 1,
                pageSize: 20,
                actions: [
                    /*{
                      label: '新增',
                      class: 'el-icon-plus',
                      clickHandler: ()=>{
                        this.$router.push({
                          path: 'add'
                        })
                      }
                    }*/
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        t__applicationNo:'',
                        t__applicationTypeCode:'',
                        c__customerContactNo:'',
                        t__applicationStatus:'',
                        t__applicationDate:[],
                        u__userName:'',
                        de__referenceNo:'',
                        de__customerName:'',
                    },
                    columns: [
                        {
                            label: '申请编号',
                            component: 'el-input',
                            field: 't__applicationNo',

                        },
                        {
                            label: '用印类型',
                            component: 'el-select',
                            field: 't__applicationTypeCode',
                            options:[
                                {
                                    label:'业务相关用印',
                                    value:'TY'
                                },
                                {
                                    label:'签约用印',
                                    value:'QY'
                                },
                                {
                                    label:'撤押用印',
                                    value:'CY'
                                },
                                {
                                    label:'债转用印',
                                    value:'ZZ'
                                },
                                {
                                    label:'助贷函件用印',
                                    value:'ZDH'
                                },
                                {
                                    label:'服务费支付用印',
                                    value:'FWF'
                                },
                                {
                                    label:'诉讼用印',
                                    value:'SS'
                                },

                            ]

                        },
                        {
                            label: '申请人',
                            component: 'el-input',
                            field: 'u__userName',

                        },
                        /*{
                          label: '贷款用途',
                          component: 'el-input',
                          field: 'fi__intendedUse',
                          span: 12
                        },*/
                        {
                            label: '用印日期',
                            component: 'date-range-picker',
                            field: 't__applicationDate',
                            op: ['gteq', 'lteq'],
                            span: 12
                        },
                        {
                            label: '关联单号',
                            component: 'el-input',
                            field: 'de__referenceNo',

                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'de__customerName',

                        },
                        {
                            label: '状态',
                            component: 'el-select',
                            field: 't__applicationStatus',
                            options:[
                                {
                                    label:'待审核',
                                    value:'Pending Approval'
                                },
                                {
                                    label:'已撤回',
                                    value:'Withdrawn'
                                },
                                {
                                    label:'审核通过',
                                    value:'Approved'
                                },
                                {
                                    label:'审核不通过',
                                    value:'Rejected'
                                },
                            ],
                            span: 12
                        },

                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                },
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '申请编号',
                        field: 't__applicationNo'
                    },
                    {
                        label: '用印类型',
                        field: 't__applicationTypeCode',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '用印日期',
                        field: 't__applicationDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '关联单号',
                        field: 'de__referenceNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'de__customerName'
                    },
                    {
                        label: '用印描述',
                        field: 't__remarks'
                    },
                    {
                        label: '申请人',
                        field: 'u__userName'
                    },
                    {
                        label: '创建时间',
                        field: 't__createdDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD HH:mm:ss')
                        }
                    },
                    {
                        label: '状态',
                        field: 't__applicationStatus',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '当前待审批节点',
                        field: 't__nodeName',
                        formatter: function (r,c,v) {
                            if(r.t__applicationStatus=='Rejected'){
                                v=''
                            }
                            return v
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessViewView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='QY'||row.t__applicationTypeCode=='SS'||row.t__applicationTypeCode=='CY'
                                }
                            },


                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessFWFViewView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='FWF'
                                }
                            },
                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessZDHViewView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return (row.t__applicationTypeCode=='ZDH')
                                }
                            },
                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessZZViewView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return (row.t__applicationTypeCode=='ZZ')
                                }
                            },

                            {
                                label: '查看',
                                class: 'el-icon-view',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessTYViewView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='TY'
                                }
                            },


                            {
                                //label: '业务负责人',

                                label: row=> {
                                    let name  = '审核';
                                    (this.tableData.variables.procInfo||[]).forEach(item=>{
                                        if((item.code=='YYCY'||item.code=='YYSS'||item.code=='QY')&&item.roleId==row.t__roleId){
                                            name = item.name
                                        }
                                    })

                                    return name
                                },
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return (row.t__applicationTypeCode=='QY'||row.t__applicationTypeCode=='SS'||row.t__applicationTypeCode=='CY')&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'

                                }
                            },

                          /*  {
                                label: '风控审核',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return (row.t__applicationTypeCode=='QY'||row.t__applicationTypeCode=='SS'||row.t__applicationTypeCode=='CY')&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        (row.t__roleId==this.tableData.variables.QY1||row.t__roleId==this.tableData.variables.SS1||row.t__roleId==this.tableData.variables.CY1)

                                }
                            },



                            {
                                label: '副总审核',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return (row.t__applicationTypeCode=='QY'||row.t__applicationTypeCode=='SS'||row.t__applicationTypeCode=='CY')&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        (row.t__roleId==this.tableData.variables.QY2||row.t__roleId==this.tableData.variables.SS2||row.t__roleId==this.tableData.variables.CY2)&&row.t__companySeal=='Y'

                                }
                            },
                            {
                                label: '总经理审核',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return (row.t__applicationTypeCode=='QY'||row.t__applicationTypeCode=='SS'||row.t__applicationTypeCode=='CY')&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        (row.t__roleId==this.tableData.variables.QY3||row.t__roleId==this.tableData.variables.SS3||row.t__roleId==this.tableData.variables.CY3)

                                }
                            },
                            {
                                label: '法人审核',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return (row.t__applicationTypeCode=='QY'||row.t__applicationTypeCode=='SS'||row.t__applicationTypeCode=='CY')&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        (row.t__roleId==this.tableData.variables.QY4||row.t__roleId==this.tableData.variables.SS4||row.t__roleId==this.tableData.variables.CY4)

                                }
                            },
                            {
                                label: '综合岗（公章）',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return (row.t__applicationTypeCode=='QY'||row.t__applicationTypeCode=='SS'||row.t__applicationTypeCode=='CY')&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        (row.t__roleId==this.tableData.variables.QY5||row.t__roleId==this.tableData.variables.SS5||row.t__roleId==this.tableData.variables.CY5)

                                }
                            },
                            {
                                label: '综合岗（法人章）',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return (row.t__applicationTypeCode=='QY'||row.t__applicationTypeCode=='SS'||row.t__applicationTypeCode=='CY')&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        (row.t__roleId==this.tableData.variables.QY6||row.t__roleId==this.tableData.variables.SS6||row.t__roleId==this.tableData.variables.CY6)

                                }
                            },*/
                            {
                                label: row=> {
                                    let name  = '审核';
                                    (this.tableData.variables.procInfo||[]).forEach(item=>{
                                        if(item.code=='YYZDH'&&item.roleId==row.t__roleId){
                                            name = item.name
                                        }
                                    })

                                    return name
                                },
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessZDHView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZDH'&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'

                                }
                            },
                            /*{
                                label: '风控审核',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessZDHView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZDH'&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        row.t__roleId==this.tableData.variables.ZDH1

                                }
                            },
                            {
                                label: '副总审核',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessZDHView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZDH'&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        row.t__roleId==this.tableData.variables.ZDH2

                                }
                            },


                            {
                                label: '总经理审核',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessZDHView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZDH'&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        row.t__roleId==this.tableData.variables.ZDH3
                                }
                            },



                            {
                                label: '法人审核',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessZDHView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZDH'&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        row.t__roleId==this.tableData.variables.ZDH4

                                }
                            },
                            {
                                label: '综合岗（公章）',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessZDHView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZDH'&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        row.t__roleId==this.tableData.variables.ZDH5

                                }
                            },
                            {
                                label: '综合岗（法人章）',
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessZDHView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZDH'&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'&&
                                        row.t__roleId==this.tableData.variables.ZDH6

                                }
                            },*/


                            {
                                label: row=> {
                                    let name  = '审核';
                                    (this.tableData.variables.procInfo||[]).forEach(item=>{
                                        if(item.code=='YYFWF'&&item.roleId==row.t__roleId){
                                            name = item.name
                                        }
                                    })

                                    return name
                                },
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessFWFView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='FWF'&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'
                                }
                            },

                            {
                                label: row=> {
                                    let name  = '审核';
                                    (this.tableData.variables.procInfo||[]).forEach(item=>{
                                        if(item.code=='YYZZ'&&item.roleId==row.t__roleId){
                                            name = item.name
                                        }
                                    })

                                    return name
                                },
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessZZView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZZ'&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'
                                }
                            },


                            {
                                label: row=> {
                                    let name  = '审核';
                                    (this.tableData.variables.procInfo||[]).forEach(item=>{
                                        if(item.code=='YYTY'&&item.roleId==row.t__roleId){
                                            name = item.name
                                        }
                                    })

                                    return name
                                },
                                class: 'el-icon-success',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ApproveContractSealProcessTYView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='TY'&&
                                        row.t__applicationStatus=='Pending Approval'&&row.t__hasRole=='true'

                                }
                            },



                            {
                                label: '重新申请',
                                class: 'el-icon-refresh-right',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ContractSealProcessView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='QY'&& (row.t__applicationStatus=='Rejected' || row.t__applicationStatus=='Withdrawn')
                                }
                            },

                            {
                                label: '重新申请',
                                class: 'el-icon-refresh-right',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ContractSealProcessSSView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='SS'&&(row.t__applicationStatus=='Rejected' || row.t__applicationStatus=='Withdrawn')
                                }
                            },

                            {
                                label: '重新申请',
                                class: 'el-icon-refresh-right',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ContractSealProcessCYView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='CY'&&(row.t__applicationStatus=='Rejected' || row.t__applicationStatus=='Withdrawn')
                                }
                            },

                            {
                                label: '重新申请',
                                class: 'el-icon-refresh-right',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ContractSealProcessFWFView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='FWF'&&(row.t__applicationStatus=='Rejected' || row.t__applicationStatus=='Withdrawn')
                                }
                            },
                            {
                                label: '重新申请',
                                class: 'el-icon-refresh-right',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ContractSealProcessZDHView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZDH'&&(row.t__applicationStatus=='Rejected' || row.t__applicationStatus=='Withdrawn')
                                }
                            },

                            {
                                label: '重新申请',
                                class: 'el-icon-refresh-right',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ContractSealProcessZZView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZZ'&&(row.t__applicationStatus=='Rejected' || row.t__applicationStatus=='Withdrawn')
                                }
                            },

                            {
                                label: '重新申请',
                                class: 'el-icon-refresh-right',
                                clickHandler: (index, row) => {
                                    this.$router.push({
                                        name: 'ContractSealProcessTYView',
                                        query: {
                                            'applicationId': row.t__applicationId,

                                        }
                                    })
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='TY'&&(row.t__applicationStatus=='Rejected' || row.t__applicationStatus=='Withdrawn')
                                }
                            },

                            {
                                label: '打印审批表',
                                class: 'el-icon-download',
                                clickHandler: (index, row) => {
                                        window.open('/ix/fang/financing/ApproveContractSealProcessQY.jasper?applicationId=' + row.t__applicationId)
                                },
                                conditions: row=> {
                                      return row.t__applicationTypeCode=='QY'
                                }
                            },
                            {
                                label: '打印审批表',
                                class: 'el-icon-download',
                                clickHandler: (index, row) => {
                                    window.open('/ix/fang/financing/ApproveContractSealProcessCY.jasper?applicationId=' + row.t__applicationId)
                                },
                                conditions: row=> {
                                      return row.t__applicationTypeCode=='CY'
                                }
                            },
                            {
                                label: '打印审批表',
                                class: 'el-icon-download',
                                clickHandler: (index, row) => {
                                    window.open('/ix/fang/financing/ApproveContractSealProcessSS.jasper?applicationId=' + row.t__applicationId)
                                },
                                conditions: row=> {
                                      return row.t__applicationTypeCode=='SS'
                                }
                            },
                            {
                                label: '打印审批表',
                                class: 'el-icon-download',
                                clickHandler: (index, row) => {
                                    window.open('/ix/fang/financing/ApproveContractSealProcessZDH.jasper?applicationId=' + row.t__applicationId)
                                },
                                conditions: row=> {
                                      return row.t__applicationTypeCode=='ZDH'
                                }
                            },

                            {
                                label: '打印审批表',
                                class: 'el-icon-download',
                                clickHandler: (index, row) => {
                                    window.open('/ix/fang/financing/ApproveContractSealProcessZZ.jasper?applicationId=' + row.t__applicationId)
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='ZZ'
                                }
                            },

                            {
                                label: '打印审批表',
                                class: 'el-icon-download',
                                clickHandler: (index, row) => {
                                    window.open('/ix/fang/financing/ApproveContractSealProcessFWF.jasper?applicationId=' + row.t__applicationId)
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='FWF'
                                }
                            },


                            {
                                label: '打印审批表',
                                class: 'el-icon-download',
                                clickHandler: (index, row) => {
                                    window.open('/ix/fang/financing/ApproveContractSealProcessTY.jasper?applicationId=' + row.t__applicationId)
                                },
                                conditions: row=> {
                                    return row.t__applicationTypeCode=='TY'
                                }
                            },

                            {
                                label: '撤回用印申请',
                                class: 'el-icon-back',
                                clickHandler: (index, row) => {
                                    this.$confirm('是否确认撤回用印申请？一旦撤回，审核人将无法再审核').then(()=> {
                                        this.withdrawSealApplication(row.t__applicationId)
                                    })
                                        .catch(()=> {

                                        })

                                },
                                conditions: row=> {
                                    return row.u__userId===this.$store.getters.userId &&row.t__applicationStatus ==='Pending Approval'
                                }
                            },

                        ]
                    }
                    ]
            }
        },
        computed:{
            filterParams: {
                get: function() {
                    return {
                        pageSize: this.pageSize,
                        pageOffset: (this.page - 1) * this.pageSize,
                        'xlist.search.t.applicationStatus' : this.applicationStatus,
                        'xlist.search.t.applicationStatus.op' : 'in',
                        'xlist.sort.dataField': 't.createdDate',
                        'xlist.sort.order': 'desc'
                    }
                },
                set:function (newVal) {

                }
            }
        },
        watch: {
            filterParams: function () {
                this.getData()
            },
        },
        mounted() {
            this.getData()
        },
        methods: {
            getData: function () {
                xhr.getSealApplicationList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res => {
                        try {
                            this.tableData = res.data
                            this.tableData.data.forEach(item=>{
                                item.t__nodeName = (this.tableData.variables.procInfo.find(item2=>item2.code ==='YY'+item.t__applicationTypeCode && item2.type ===item.t__nodeType  )||{}).name


                            })
                        } catch (e) {

                        }
                    })
            },
            withdrawSealApplication: function (applicationId){
                xhr.withdrawSealApplication(
                    {t__applicationId:applicationId },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                               this.getData()
                            }else{
                                this.$message.error(res.data.msgs[0].text)
                            }

                        }catch (e) {

                            this.$message.error(error.msgs[0].text)

                        }
                    }
                )

            }

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ContractSealProcessList.vue